import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from '@app/core/auth/user.service';
import { ExtendedInformationService } from '@app/core/device-information/extended-information.service';

@Injectable({ providedIn: 'root' })
export class HttpService {
    private http = inject(HttpClient);
    private userService = inject(UserService);
    private extendedInformationService = inject(ExtendedInformationService);

    public locationId: string;

    request<T>(url: string, method, data?, responseType?) {
        return this.http.request<T>(method, url, {
            headers: this.getHeaders(),
            body: data,
            responseType: responseType,
        });
    }

    getHeaders(): { [header: string]: string | string[] } {
        const headers = {
            'inspekt-location-id': this.locationId || '',
            'inspekt-tenant-id': this.userService.currentUser.tenantId || '',
        };

        this.extendedInformationService.addCustomHeader(headers);

        return headers;
    }

    get<T>(url: string, params?: HttpParams): Observable<HttpResponse<T>> {
        return this.http.get<T>(url, {
            observe: 'response',
            headers: this.getHeaders(),
            params: params,
        });
    }

    getWithoutHeader(url: string) {
        return this.http.get(url, {
            observe: 'response',
        });
    }

    post(url: string, data: any, customResponseType?: any) {
        return this.http.post(url, data, {
            observe: 'response',
            responseType: customResponseType,
            headers: this.getHeaders(),
        });
    }

    postWithoutHeader(url: string, data: any) {
        return this.http.post(url, data, {
            observe: 'response',
        });
    }

    put(url: string, data: any) {
        return this.http.put(url, data, {
            headers: this.getHeaders(),
            observe: 'response',
        });
    }

    delete(url: string) {
        return this.http.delete(url, {
            headers: this.getHeaders(),
            observe: 'response',
        });
    }

    patch(url: string, data: any) {
        return this.http.patch(url, data, {
            headers: this.getHeaders(),
            observe: 'response',
        });
    }
}
